const navbar = document.querySelector(".header");
const closeBtn = document.querySelector(".menu-drawer__close-button");

document.querySelectorAll(".menu-list__link, a.scrolltosection, .menu-drawer__menu-item").forEach(link => {
  link.addEventListener("click", function(e) {
    e.preventDefault();

    // If clicked element is from menu drawer, trigger close button
    if (this.classList.contains("menu-drawer__menu-item") && closeBtn) {
      closeBtn.click();
    }

    const target = this.getAttribute("href");
    const section = document.querySelector(`[data-secid="${target}"]`);

    if (!section) return;

    const navbarHeight = navbar.getBoundingClientRect().height;

    const top =
      section.getBoundingClientRect().top +
      window.pageYOffset -
      navbarHeight;

    window.scrollTo({
      top: top,
      behavior: "smooth"
    });
  });
});

document.querySelectorAll(".menu__item a").forEach(link => {
  link.addEventListener("click", function(e) {

    let target = this.getAttribute("href");
    const url = "https://oldgloryvpn.com/#pricing";

    if(target == url) {
      e.preventDefault();
      target = new URL(url).hash;
    }

    const section = document.querySelector(`[data-secid="${target}"]`);

    if (!section) return;

    const navbarHeight = navbar.getBoundingClientRect().height;

    const top =
      section.getBoundingClientRect().top +
      window.pageYOffset -
      navbarHeight;

    window.scrollTo({
      top: top,
      behavior: "smooth"
    });
  });
});


// On page load / Direct open link like https://oldgloryvpn.com/#pricing
document.addEventListener("DOMContentLoaded", function () {
  if (window.location.hash) {
    const el = document.querySelector(`[data-secid="${window.location.hash}"]`);
    console.log(window.location.hash);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }
});


// Show Hide Price Section
document.addEventListener("DOMContentLoaded", function () {

  // Select both plan containers
  const planTabs = document.querySelectorAll(".monthly-plan-tab, .yearly-plan-tab");

  planTabs.forEach(plan => {
    const buttons = plan.querySelectorAll(".toggle-button-box a");
    const oneDevice = plan.querySelector(".one-device");
    const threeDevice = plan.querySelector(".three-device");

    // Hide three-device by default (only inside this plan)
    if (threeDevice) {
      threeDevice.style.display = "none";
    }

    buttons.forEach(button => {
      button.addEventListener("click", function (e) {
        e.preventDefault();

        // Remove active class from buttons inside THIS plan only
        buttons.forEach(btn => btn.classList.remove("active"));

        // Add active to clicked button
        this.classList.add("active");

        // Get target section
        const targetClass = this.getAttribute("href").replace("#", "");

        // Toggle sections inside THIS plan only
        const targetSection = plan.querySelector("." + targetClass);

        if (targetSection) {
          // Hide both first
          if (oneDevice) oneDevice.style.display = "none";
          if (threeDevice) threeDevice.style.display = "none";

          // Show selected
          targetSection.style.display = "block";
        }
      });
    });
  });

});